import { FC, ReactNode, Suspense, lazy } from 'react';
import { XmEmailGroups } from 'src/component/emailGroups/XmEmailGroups';
import { XmSpinner } from 'src/component/spinner/XmSpinner';
import { EXPORTER_SECTIONS, ExporterSectionPath } from 'src/content/tools/exporter/exporterMenu';
import { RoutePath } from 'src/data/Routes';
import { RouteToolSections } from 'src/routing/RouteToolSections';

const Exporter = lazy(() => import('src/content/tools/exporter/Exporter'));

const SECTION_CONTENT: Record<ExporterSectionPath, ReactNode> = {
  '/exports': <Suspense fallback={<XmSpinner />}><Exporter /></Suspense>,
  '/email': <XmEmailGroups />,
};

export const RouteExporter: FC = () => (
  <RouteToolSections
    rootPath={RoutePath.EXPORTER}
    title='Exporter'
    sections={EXPORTER_SECTIONS}
    renderSection={section => SECTION_CONTENT[section.path]}
  />
);
